export const TITLE_LENGTH = 70
export const DESCRIPTION_LENGTH = 1000
export const CROWDFUNDING_DESCRIPTION_LENGTH = 1000
export const NOTE_LENGTH = 400

export const DESCRIPTION_ROWS = 6
export const SEND_NOTE_ROWS = 3
